import { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { FlowCard } from "./components/FlowCard";
import { FLOW_OPTIONS } from "./components/ConfigureCallFlows";
import { useCallFlowMutation } from "./hooks/useCallFlowMutation";
import { ECallFlowType, EQueueDispatchMode } from "./enums/call-flow.enum";
import { useCallSettingsQuery } from "./hooks/useCallFlowQuery";
import { useAppSelector } from "src/redux/hooks/redux";
import { selectCurrentCompany } from "src/redux/features/user/selectors/userState.selectors";


export const ConfigureCallFlow = () => {
    const company = useAppSelector(selectCurrentCompany);

    const { update } = useCallFlowMutation();
    const { data: callFlow, isLoading } = useCallSettingsQuery(company?.id!);

    const [localSelectedFlow, setLocalSelectedFlow] =
        useState<EQueueDispatchMode | null>(null);

    const selectedFlow =
        localSelectedFlow ??
        (callFlow?.queueDispatchMode as EQueueDispatchMode | undefined);

    const handleSave = async (flowType: EQueueDispatchMode) => {
        setLocalSelectedFlow(flowType);
        try {
            await update.mutateAsync({
                companyId: company?.id!,
                payload: {
                    flowType: ECallFlowType.QUEUE,
                    queueDispatchMode: flowType,
                },
            });
        } catch {
            setLocalSelectedFlow(null);
        }
    };

    // TODO: ADD SKELETON
    if (isLoading) return null;

    return (
        <Stack spacing={2.5} sx={{ width: "100%", px: 3, py: 1 }}>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: 1.25,
                }}
            >
                {FLOW_OPTIONS.map((opt) => (
                    <FlowCard
                        key={opt.key}
                        option={opt}
                        disabled={opt.disabled}
                        selected={selectedFlow === opt.key}
                        onSelect={() => handleSave(opt.key)}
                    />
                ))}
            </Box>
        </Stack>
    );
};